<div bsModal #createOrEditModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="createOrEditModal" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #workFlowItemForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span>{{l("Reject")}} {{title}}</span>
                    </h4>                    
                    
                    
                 <button type="button" class="btn-close" (click)="close()" aria-label="Close" [disabled]="saving"></button>
             
                </div>
                <div class="modal-body">
                 

                    <div class="my-3">
                        <label class="form-label" for="WorkFlowItem_Approve_Description"><b>{{l("AreYouSureToReject")}} {{title}}?</b></label>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="WorkFlowItem_Approve_Description">{{l("Opinion")}}*</label>
                        <input type="text" #WorkFlowItem_Approve_Description="ngModel" id="WorkFlowItem_Approve_Description" class="form-control" [(ngModel)]="description" required name="WorkFlowItem_Approve_Description"/>
                        <validation-messages [formCtrl]="WorkFlowItem_Approve_Description"></validation-messages>
                    </div>
					
					
					

                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">{{l("Cancel")}}</button>
                    <button type="submit" class="btn btn-warning blue" [disabled]="!workFlowItemForm.form.valid" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"><i class="fa fa-reply-all"></i> <span>{{l("Reject")}}</span></button>
                </div>
            </form>
        </div>
    </div>

</div>